import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { Button, Container, SpacerRow } from '@zg-rentals/multibrand-ui';
import Section from '@rental-manager/components/Section';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import HeartHome from '@assets/HeartHome.svg';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import StringConstants from '@common/constants/StringConstants';
import { ExpandableDisclaimer } from '@zillow/zrs-comet';
import { IStyledTextModel } from '@rental-manager/models/Types';

type RentalProtectionDisclaimers = IStyledTextModel[];

type Props = {
  onClose: () => void;
  onContinue: () => void;
  onBack?: () => void;
  fromDashboard?: boolean;
  rentalProtectionDisclaimers: RentalProtectionDisclaimers;
  listingAlias: string;
};

const DifferentValueThanLeaseWarning: React.FC<React.PropsWithChildren<Props>> = (props: Props): React.ReactElement => {
  const { listingAlias } = props;
  const managePolicyUrl = StringConstants.LINKS.RENTAL_PROTECTION.MANAGE_POLICY_PAGE(listingAlias);
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      header={props.fromDashboard ? 'Payment settings' : 'Payment setup'}
      onRequestClose={props.onClose}
      onClickBack={props.fromDashboard ? props.onBack : null}
      dataAutoTestId="landlord-rental-protection-rent-amount-differ-from-lease"
    >
      {
        <Container>
          <Section>
            <img src={HeartHome as unknown as string} alt="" className="centeredImg" />
          </Section>
          <Section>
            <Text type="h5" className="txtC boldText zillowInsuranceSubHeading">
              Zillow Insurance Services
            </Text>
            <Text type="h4" className="txtC boldText">
              Rent amount is different than in lease
            </Text>
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <Text>
              The monthly rent amount you entered is different from the monthly rent amount in the lease you selected.
              If you request&nbsp;
              <Link escape={false} target="_blank" to={managePolicyUrl} type="inlineBlockDisplay">
                Rental Protection
              </Link>
              &nbsp;offered through Zillow Insurance Services, insurance coverage will be&nbsp;
              <strong>based on the monthly rent amount in the lease.</strong>
            </Text>
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <ExpandableDisclaimer disclaimerContent={props.rentalProtectionDisclaimers} title="Legal Disclaimer" />
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <Button onClick={props.onContinue} type="primary" full>
              OK
            </Button>
          </Section>
        </Container>
      }
    </Modal>
  );
};

export default DifferentValueThanLeaseWarning;
